export default {
  displayNameKey: 'customized_skill',
  icon: 'menu_customized_skill',
  pages: {
  },
};



// WEBPACK FOOTER //
// ./src/modules/CustomizedSkill/index.js